import { WidgetArticleType, useWidgetContext } from 'providers'
import { useContext, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import useRouteState from './useRouteState'
import BrandsContext from '../contexts/BrandsContext'
import { CampaignContext } from '../contexts/CampaignContext'
import { SmsNumberCampaignContext } from '../contexts/SmsNumberCampaignContext'

const SMS_REGISTRATION = {
    section: 'sms-registration',
    articles: {
        brandEnrollment: 'brand-enrollment',
        campaignEnrollment: 'campaign-enrollment',
        smsNumberEnrollment: 'sms-number-enrollment'
    }
} as const

const tabToCategoryMap = {
    brands: SMS_REGISTRATION.articles.brandEnrollment,
    campaigns: SMS_REGISTRATION.articles.campaignEnrollment,
    'number-assignement': SMS_REGISTRATION.articles.smsNumberEnrollment
} as const

// one day this will hopefully be part of the main widget
const useWidget = () => {
    const {
        findSectionBySlug,
        setPageBasedData,
        pageBasedData,
        findArticlesBySectionAndCategory,
        setSelectedSection,
        hideBottomWidget,
        showBottomWidget
    } = useWidgetContext()

    const {
        brands,
        initialFetching: brandsInitialFetching
    } = useContext(BrandsContext)

    const { initialFetching: campaignsInitialFetching } = useContext(CampaignContext)
    const { initialFetching: numbersInitialFetching } = useContext(SmsNumberCampaignContext)

    const { currentTab, activePage } = useRouteState()
    const { pathname, hash } = useLocation()

    useEffect(() => {
        if (!pageBasedData?.slug) return
        const slug =
            (currentTab === 'brands' && activePage === 'list' && !brands.length)
                ? null
                : tabToCategoryMap[currentTab ?? 'brands']

        const sectionSlug = SMS_REGISTRATION.section
        const locationWithHash = pathname + hash
        const section = findSectionBySlug(sectionSlug)
        if (section) {
            const articles: WidgetArticleType[] = slug
                ? (findArticlesBySectionAndCategory(sectionSlug, slug) || [])
                : (section.articles || [])

            setPageBasedData({
                ...section,
                articles,
                selectedArticleCategory: slug
            }, locationWithHash)
        }
        setSelectedSection(slug ?? '')
    }, [
        activePage,
        brands.length,
        currentTab,
        hash,
        pageBasedData?.selectedArticleCategory,
        pageBasedData?.slug,
        pathname
    ])

    useEffect(() => {
        if (brandsInitialFetching || campaignsInitialFetching || numbersInitialFetching) {
            hideBottomWidget()
        } else {
            showBottomWidget()
        }

        // Reveal bottom widget when leaving the page or changing tab to avoid it being hidden on other pages
        return () => {
            showBottomWidget()
        }
    }, [brandsInitialFetching, campaignsInitialFetching, numbersInitialFetching])
}

export default useWidget
